import _ from 'lodash'
import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../../../redux/loading'

import { ImportValidationActions } from './actions'
import { ImportValidationState as ImportValidationState } from './types'

export const initialState: ImportValidationState = {
  data: { items: [], isValidationError: false, allEnabled: false },
  page: 1,
  totalPages: 1
}

export const reducer: Reducer<ImportValidationState, ImportValidationActions> = (
  state = initialState,
  action
): ImportValidationState => {
  switch (action.type) {
    case getType(ImportValidationActions.fetchData): {
      return {
        ...state,
        data:
          action.payload.importId && state.importId && action.payload.importId !== state.importId
            ? initialState.data
            : state.data,
        importId: action.payload.importId ?? state.importId,
        page: action.payload.page
      }
    }
    case getType(ImportValidationActions.setData): {
      return {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        totalPages: action.payload.totalPages
      }
    }
    case getType(ImportValidationActions.setEnabled): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i => ({
            ...i,
            enabled: action.payload.itemId === i.id ? action.payload.enabled : i.enabled
          })),
          allEnabled: !action.payload.enabled ? false : state.data.allEnabled
        }
      }
    }
    case getType(ImportValidationActions.setAllEnabled): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i => ({
            ...i,
            enabled: _.size(i.errors) > 0 ? i.enabled : action.payload.enabled
          })),
          allEnabled: action.payload.enabled
        }
      }
    }
    default:
      return state
  }
}

export const importValidationReducer = withLoadingReducer(reducer, 'importValidation', initialState)
